import styled from "styled-components";
import {
  Description,
  FlexContainer,
  Title,
} from "../components/CommonComponents";
import { Arrow, Cicle, EmailIcon, Star } from "../components/svgs";
import backgound_image from "../images/background5.jpg";
import { scrollY_to_target } from "../utills/utills";

const Main = styled.div`
  position: relative;
  top: 5%;
  padding: 0px 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 1360px) {
    top: -0%;
  }
`;
const Email = styled.div`
  margin-top: 20px;
  height: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  cursor: pointer;
  @media (max-width: 1360px) {
    margin-top: 50px;
  }
  & svg{
    position: absolute;
  }
  & svg.circle:first-child{
    top:0px;
  }
  & svg.circle:nth-child(2){
    bottom: 0px;
  }
  & svg.logo{
    top:110px;
    bottom:120px;
  }
  & h1{
    position : relative;
    top: 160px;
    font-weight: 600;
    font-size : 0.9rem;
    &::after{
      position: absolute;
      bottom: 2px;
      left: 0;
      content: "";
      width: 100%;
      height: 2px;
      background-color: white;
    }
  }
`;
const Footer = styled.div`
  width: 90%;
  position: absolute;
  bottom: 5%;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 1360px) {
    flex-direction: column;
  }
`;
const ScrollUp = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  bottom: -15%;
  cursor: pointer;
  transform: rotateZ(180deg);
  @media (max-width: 1360px) {
    bottom: -5%;
  }
`;
const Copyright = styled.span`
  font-size: 0.7rem;
`;
const Link = styled.a`
  font-size: 0.7rem;
`;

function Contact() {
  const onClick = () => {
    const email_address = "contact@im-fine.co.kr";
    navigator.clipboard.writeText(email_address);
    alert("The email address has been copied");
    const a = document.createElement("a");
    a.href = `mailto:${email_address}`;
    a.click();
  };
  return (
    <FlexContainer
      id="contact"
      img={backgound_image}
      className="page-container"
    >
      <Main>
        <Title>Contact us</Title>
        <Description>
          If you have any questions, please email us at any time.
        </Description>
        <Email onClick={onClick}>
          <EmailIcon />
          <Cicle/>
          <Cicle/>
          <h1>contact@im-fine.co.kr</h1>
        </Email>
      </Main>
      <ScrollUp onClick={() => scrollY_to_target("introduction")}>
        <Star />
        <Arrow />
      </ScrollUp>
      <Footer>
        <Copyright>
          Copyright © 2022 I M FINE inc. All Rights Reserved.
        </Copyright>
        <Link href="http://www.im-fine.co.kr"> www.im-fine.co.kr </Link>
      </Footer>
    </FlexContainer>
  );
}

export default Contact;
